// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnitCompetencyItem_wrapper__30EES"};